/*
 * defaults.ts — a configuração do site embutida no bundle: os MESMOS valores
 * que a migração `supabase/migrations/0003_members_area.sql` semeia. É o que a
 * topbar e o rodapé mostram enquanto `GET /site` carrega e quando ele falha
 * (rollback na Lambda, deploy fora de ordem, rede) — o chrome nunca cai.
 *
 * Código de produção: nada de demonstração aqui, e nenhum link para fora do
 * portal (a guarda do bundle varre o build).
 */
import type { SiteConfig, SiteLink, SiteLinkArea } from '../api/types';

function seedLink(
  id: string,
  area: SiteLinkArea,
  position: number,
  label: string,
  href: string,
  badge = '',
): SiteLink {
  return {
    id: `lnk_${id.padStart(32, '0')}`,
    area,
    label,
    href,
    subtitle: '',
    icon: '',
    badge,
    enabled: true,
    position,
  };
}

const TRACK_LABEL = 'Trilha Communications Cloud';

export const DEFAULT_SITE: SiteConfig = {
  settings: {
    brandDescription:
      'Formação em Salesforce Communications Cloud. Aprenda como as soluções de telecom são ' +
      'modeladas, configuradas e integradas.',
    whatsappPhone: '',
    copyrightHolder: 'Sovra',
    legalName: '',
    contactEmail: 'contato@sovra.com.br',
    communityLabel: 'Comunidade',
    youtubeUrl: '',
  },
  links: {
    navbar: [
      seedLink('1', 'navbar', 0, TRACK_LABEL, '/cursos', 'NOVO'),
      seedLink('2', 'navbar', 1, 'Cursos', '/cursos'),
      seedLink('3', 'navbar', 2, 'Blog', '/blog'),
      seedLink('4', 'navbar', 3, 'Ferramentas', '/ferramentas'),
      seedLink('5', 'navbar', 4, 'Sobre', '/sobre'),
    ],
    footerPlatform: [
      seedLink('11', 'footer_platform', 0, TRACK_LABEL, '/cursos'),
      seedLink('12', 'footer_platform', 1, 'Cursos', '/cursos'),
      seedLink('13', 'footer_platform', 2, 'Blog', '/blog'),
      seedLink('14', 'footer_platform', 3, 'Ferramentas', '/ferramentas'),
      seedLink('15', 'footer_platform', 4, 'Sobre', '/sobre'),
    ],
    footerElsewhere: [],
    footerSocial: [],
    footerLegal: [
      seedLink('21', 'footer_legal', 0, 'Privacidade', '/privacidade'),
      seedLink('22', 'footer_legal', 1, 'Termos de Uso', '/termos'),
    ],
  },
  // Sem equipe semeada: o /sobre mostra o contato e "a equipe será apresentada em breve".
  team: [],
};
